import { formatDateShort } from "../../helperfunctions/helperfunctions";
import { useActiviteiten } from "../../utils/activiteiten";
import { useEffect } from "react";




const ActiviteitenSoon = () => {

    const act = useActiviteiten();

    useEffect(() => {
        act.loadActiviteiten();
    },[]);



    return (
        <>
            <div className="dashboardContainer">
                <h3>Activiteiten deze en volgende maand:</h3>
                <div className="soonActiviteiten">
                    { act.soonActiviteiten && act.soonActiviteiten.map((item, i) => {
                    const shownDatum = formatDateShort(item.datum);
                    return (
                    <div key={item._id} className="listItem"> 
                        <span className="homeDatum" key={item.datum}>{shownDatum}</span>
                        <span className="itemNaam"  key={item.naam}>{item.naam}</span>
                    </div>
                    )
                    })}
                </div>
            </div>
        </>
    );
}

export default ActiviteitenSoon;